import { useNavigate } from 'react-router-dom';

export type DashStatsProps = {
  characters: number | null;
  cash: number;
  premiumName: string;
  premiumNote: string;
  nextWar: string;
};

export function DashStats({ characters, cash, premiumName, premiumNote, nextWar }: DashStatsProps) {
  const navigate = useNavigate();
  return (
    <section className="dashboard-stats">
      <article className="dash-stat red">
        <div className="stat-icon">♙</div>
        <div><small>Personagens</small><strong>{characters ?? '...'}</strong><p>criados na conta</p></div>
      </article>
      <article className="dash-stat gold">
        <div className="stat-icon">◉</div>
        <div><small>Saldo <span className="lcoin">lcoin</span></small><strong>{cash.toLocaleString('pt-BR')}</strong><p>recarregar</p></div>
        <button title="Recarregar" onClick={() => navigate('/dashboard/recarga')}>+</button>
      </article>
      <article className="dash-stat">
        <div className="stat-icon">♛</div>
        <div><small>Premium atual</small><strong>{premiumName}</strong><p>{premiumNote}</p></div>
        <button title="Premium" onClick={() => navigate('/dashboard/premium')}>▣</button>
      </article>
      <article className="dash-stat blue">
        <div className="stat-icon">⚔</div>
        <div><small>Próxima guerra</small><strong>{nextWar}</strong><p>Capella vs Procyon</p></div>
        <button title="Guerra" onClick={() => navigate('/#guerra')}>⚑</button>
      </article>
    </section>
  );
}
